import { forwardRef, CSSProperties, HTMLAttributes } from 'react';

interface SpanProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'style'> {
    /** Use light font. */
    light?: boolean;
    /** Use bold font. */
    bold?: boolean;
    /** Font size. If given as a number, unit will be px. */
    fontSize?: string | number;
    /** Text colour (CSS 'color'). */
    colour?: string;
    /** Use `display: block;`. */
    block?: boolean;
    /** Additional styles. */
    style?: CSSProperties;
}

/** <span> tag which takes commonly used style properties as props. */
const Span = forwardRef<HTMLSpanElement, SpanProps>(
    (
        {
            light,
            bold,
            fontSize,
            colour,
            block = false,
            children,
            style: extraStyles,
            ...props
        },
        ref
    ) => {
        const style: CSSProperties = {
            fontWeight: light ? 100 : bold ? 300 : undefined,
            fontSize,
            color: colour,
            display: block ? 'block' : 'inline',
            ...(extraStyles || {}),
        };

        return (
            <span ref={ref} style={style} {...props}>
                {children}
            </span>
        );
    }
);

Span.displayName = 'Span';

export default Span;
